import { reactive } from '@/core/reactive/reactive';
import { LoginConfig } from '@/core/config';
import { RecoveryClient } from '@/core/reactive/services/sdk';

export const RecoveryService = reactive.service(
  'recovery',
  RecoveryClient,
)(Service => new Service(LoginConfig.current?.api?.host ?? ''));

export const RecoveryServiceReactor = RecoveryService.reactor('recoveryServiceReactor', {
  success: () => {},
});
